/* eslint-disable import/no-anonymous-default-export */
export default {
    clientId: window.REACT_APP_OKTA_ID,
    issuer: 'https://woodmackenzie.okta.com/oauth2/default',
    scopes: ['openid', 'profile', 'email'],
    pkce: true
};